export default {"src":"/_next/static/media/ach_link_successful_checkmark.036ecd05.svg","height":39,"width":40,"blurWidth":0,"blurHeight":0};